<template>
  <section class="custom-chat" style="background: #efe7dd url('imgs/bg_wtt.jpg') repeat;" v-if="getTemCurrentConversa">
    <div class="mensagens" ref="msgContainer">
      <item-mensagen v-for="(msgItem, index) in getCurrentConversa" :key="'item-mensagen-' + index"
        :modal="'modal-' + index" :avatar="msgItem.avatar" :legend="msgItem.legend" :isProprio="msgItem.isProprio"
        :exibirData="msgItem.exibirData" :hora="msgItem.hora" :data="msgItem.data" :mensagem="msgItem.mensagem"
        :idOperador="msgItem.idOperador" @addContact="saveContact($event)"></item-mensagen>
      {{ scrollMsg() }}
    </div>

    <div class="msg-queue-alert" v-if="getMsgQueue.length && (first || showMsgsQueue)">
      <span @click="showMsgsQueue = true">
        Você adicionou {{getMsgQueue.length}} {{ getMsgQueue.length > 1 ? 'mensagens' : 'mensagem' }} à fila de envio. Para visualizar e editar a fila, clique aqui
      </span>
      <i 
        class="fas fa-info"
        title="A fila de envio é uma lista de mensagens que serão enviadas automaticamente após a primeira resposta do cliente nesta conversa"
      ></i>
    </div>

    <div class="d-flex">
      <start-conversation v-if="showTemplate" @started="start($event)" :clientName="clientName" :allTemplates="allTemplates"></start-conversation>

      <div class="text-area" v-else>
        <textarea ref='textArea' class="form-control" v-model="msg" @keydown.enter.exact.prevent
          @keyup.enter.exact="addCurrMsg(first)" @paste="fileToClipboard" name="mensagemNew"
          :placeholder="(first || showMsgsQueue) ? 'Adicione uma mensagem à fila de envio...' : 'Digite sua mensagem...'">
        </textarea>

        <div class="position-relative">
          <button @click.prevent="addCurrMsg(first)" class="btn" :class="{'send-button': (!first && !showMsgsQueue), 'schedule-button': (first || showMsgsQueue)}" :title="(first || showMsgsQueue) ? 'Adicione à fila' : 'Envie sua mensagem'">
            <i v-if="!first && !showMsgsQueue" class="fas fa-paper-plane"></i>
            <i v-else class="fas fa-clock"></i>
          </button>

          <div v-if="getMsgQueue.length && (first || showMsgsQueue)" class="msg-queue-count">{{ getMsgQueue.length }}</div>
        </div>

        <button class="btn btn-primary button-send-absolut" type="button"
          @click.prevent="changeFile()">
          <i class="fas fa-paperclip"></i>
        </button>

        <voice-recorder :queueMessage="queueVoiceRecorder">
        </voice-recorder>

        <button type="button" class="btn-emoji" @click="showEmojis">
          <svg class="btn-emoji-open" data-svg='true' style="max-height:18px" xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" viewBox="0 0 106.059 106.059" fill="gray">
            <path
              d="M90.544 90.542c20.687-20.684 20.685-54.341.002-75.024-20.688-20.689-54.347-20.689-75.031-.006-20.688 20.687-20.686 54.346.002 75.034 20.682 20.684 54.341 20.684 75.027-.004zM21.302 21.3c17.494-17.493 45.959-17.495 63.457.002 17.494 17.494 17.492 45.963-.002 63.455-17.494 17.494-45.96 17.496-63.455.003-17.498-17.498-17.496-45.966 0-63.46zM27 69.865s-2.958-11.438 6.705-8.874c0 0 17.144 9.295 38.651 0 9.662-2.563 6.705 8.874 6.705 8.874C73.539 86.824 53.03 85.444 53.03 85.444S32.521 86.824 27 69.865zm6.24-31.194a6.202 6.202 0 1 1 12.399.001 6.202 6.202 0 0 1-12.399-.001zm28.117 0a6.202 6.202 0 1 1 12.403.001 6.202 6.202 0 0 1-12.403-.001z">
            </path>
          </svg>

          <div class='emoji-frame' v-if="emojis">
            <VEmojiPicker @select="selectEmoji" :i18n="i18n" />
          </div>
        </button>

        <input type="file" name="sendFile" id="sendFile" @change="confirmFile()"
          accept=".doc,.docx, application/msword, application/zip, text/plain, application/pdf, image/jpeg, image/png, text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ref="sendFile" hidden />

        <button class="btn transferir chatMensagem-button" type="button" @click.prevent="openModalTransf()" :disabled="first">
          Transferir
        </button>

        <button class="btn btn-danger chatMensagem-button" type="button" id="finalizar" @click.prevent="endCurrChat()">
          Finalizar
        </button>
      </div>
    </div>

    <div class="modal-2" v-if="modal">
      <div class="modal-content-my">
        <form class="form-modal">
          <div class="modal-head">
            <h3 class="title-text">Arquivo selecionado</h3>
            <span @click="btnClose()" class="closeBtn">&times;</span>
          </div>

          <div>
            <p class="opcoes-filename">{{ filename }}</p>
          </div>
          
          <div>
            <button class="btn btn-success chatMensagem-button widthButton" type="button" @click.prevent="sendFile(first)">
              Enviar
            </button>
          </div>
        </form>
      </div>
    </div>

    <component :is="componentName" v-on:dismissModal="dismissModal" v-on:sendSelectedFile="sendSelectedFile($event, first)"
      v-on:sendTotextArea="sendTotextArea" />

    <ModalTransferencia ref="modalTrans" />

    <MsgsQueueModal v-if="showMsgsQueue" :msgs="getMsgQueue" @close-modal="closeMsgsQueueModal" @update-msgs-queue="updateMsgsQueue" />
  </section>

  <div v-else>

    <div id="home" class="_3qlW9">
      <div class="_3BqNZ">
        <div data-asset-intro-image="true" class="_2Uo0Z "
          style="transform: scale(1); opacity: 1; background-image: url('imgs/advance-logo.png');"></div>
        <div class="_2MnNk" style="opacity: 1; transform: translateY(0px);">
          <h1 class="iHhHL">Advance Management</h1>
          <div class="_1Y6o1">
            <div class="_3zFlu"></div>
            <div class="_3cK8a">
              <span data-icon="laptop" class="">
                <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 18" width="21" height="18">
                  <path fill="#9DA3A5"
                    d="M10.426 14.235a.767.767 0 0 1-.765-.765c0-.421.344-.765.765-.765s.765.344.765.765-.344.765-.765.765zM4.309 3.529h12.235v8.412H4.309V3.529zm12.235 9.942c.841 0 1.522-.688 1.522-1.529l.008-8.412c0-.842-.689-1.53-1.53-1.53H4.309c-.841 0-1.53.688-1.53 1.529v8.412c0 .841.688 1.529 1.529 1.529H1.25c0 .842.688 1.53 1.529 1.53h15.294c.841 0 1.529-.688 1.529-1.529h-3.058z">
                  </path>
                </svg>
              </span>
              <div class="_1lrYJ">Adicione um contato para iniciar uma conversa.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import ItemMensagen from "./ItemMensagen";
import StartConversation from "./StartConversation";
import swal from "sweetalert";
import $ from "jquery";
import voiceRecorder from './VoiceRecorder.vue';
import ModalCatalogo from './ModalCatalogo.vue';
import ModalTransferencia from "./ModalTransferencia";
import { VEmojiPicker } from "v-emoji-picker";
import MsgsQueueModal from "./MsgsQueueModal.vue";

window.$eventMessage = new Vue();

const dateTimeFormat = new Intl.DateTimeFormat("pt-br", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "numeric",
  minute: "numeric",
});

const toBase64 = (file) => {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.readAsDataURL(file);
    reader.onloadend = function () {
      resolve(reader.result);
    };
  });
};

export default {
  name: "ChatMensagem",
  data: () => ({
    channel: '',
    msg: "",
    first: false,
    showTemplate: false,
    componentName: '',
    clientName: '',
    clientCpfCnpj: '',
    modal: false,
    emojis: false,
    attLog: [],
    msgTemplate: null,
    i18n: {
      search: 'Pesquisar...',
      categories: {
        Activity: "Atividades",
        Flags: "Bandeiras",
        Foods: "Comida",
        Frequently: "Frequentes",
        Objects: "Objetos",
        Nature: "Natureza",
        Peoples: "Pessoas",
        Symbols: "Símbolos",
        Places: "Locais"
      }
    },
    showMsgsQueue: false,
    allTemplates: [],
    dbTemplates: [],
    options: "",
    newFileNamePrint: null
  }),
  components: {
    ModalTransferencia,
    ModalCatalogo,
    voiceRecorder,
    VEmojiPicker,
    ItemMensagen,
    MsgsQueueModal,
    ...mapGetters(["getCurrentConversa"]),
  },
  methods: {
    ...mapMutations([
      "addMensagemCurrentConversa",
      "queueMessage",
      "addTemplateMessage",
      "endCurrentConversa",
      "transfProcess",
      "listenSessionEvents",
      "listenMsgQueue",
      "changeMsgQueue",
      "sendMsgQueue",
    ]),
    ...mapActions(["transferOptions"]),
    saveContact(data) {
      this.$emit('addContact', data)
    },
    sendTotextArea(data) {
      this.msg = data;
      this.$refs.textArea.focus();
    },
    setMsgRapida() {
      this.componentName = 'mensagem-rapida';
    },
    selectEmoji(emoji) {
      this.emojis = false;
      this.msg += emoji.data;
      this.$refs.textArea.focus();
    },
    //tirando caracter especial e colococando _ no nome do arquivo
    generateTimestampedFilename(originalName) {
      const extension = originalName.split('.').pop();
      let baseName = originalName.replace(/\.[^/.]+$/, "");  
      baseName = baseName.replace(/[^a-zA-Z0-9]/g, "_"); 
      const timestamp = moment().format("YYYYMMDD_HHmmss");
      return `${timestamp}_${baseName}.${extension}`;
    },
    dismissModal() {
      this.componentName = '';
    },
    setMsgRapida() {
      this.componentName = 'mensagem-rapida';
    },
    showEmojis(e) {
      if (e.target.tagName == 'INPUT' || e.target.tagName == 'DIV') return;
      if (e.target.className == 'container-search') return;
      if (e.target.className.animVal == '') return;

      this.emojis = !this.emojis;
    },
    async addMsg(first = false, txt = null, file = null, filename = null, typeFile = null) {
      this.emojis = false;

      const obj = {
        isProprio: true,
        data: dateTimeFormat.format(new Date())
      };

      if (file != null && typeFile != null) {
        if (!filename) {
        filename = this.generateTimestampedFilename(file.name || "arquivo.txt");
      }


        const reader = await toBase64(file);
        obj.file = reader;
        obj.filename = filename;
        obj.type = typeFile;

        if (first) {
          this.queueMessage(obj);
        } else {
          this.addMensagemCurrentConversa(obj);
        }
      } else {
        obj.mensagem = `*${user.getName()}:*\n\n${txt}`;

        if (first) {
          this.queueMessage(obj);
        } else {
          this.addMensagemCurrentConversa(obj);
        }
      }

      this.clearMsg();
      this.scrollMsg();
    },
    async addTemplateMsg(data = null) {
      this.emojis = false;
      this.addTemplateMessage(data);
      this.clearMsg();
      this.scrollMsg();
    },
    formatMsgTemplate(template) {
      let tempReplace = template[0].text.replace("{{1}}", this.clientName);
      tempReplace = tempReplace.replace("{{2}}", user.getName());
      return `<span>${tempReplace}</span><br>`;
    },
    clearMsg() {
      this.msg = "";
    },
    scrollMsg() {
      try {
        requestAnimationFrame(() => {
          if (this.$refs.msgContainer) {
            return (this.$refs.msgContainer.scrollTop =
              this.$refs.msgContainer.scrollHeight);
          }
        });
      } catch {
        return;
      }
    },
    addCurrMsg(first = false) {
      this.addMsg(first, this.msg);
    },
    changeFile() {
      if (process.env.MIX_CATALOGO) {
        this.componentName = 'modal-catalogo';
        return;
      }

      this.$refs.sendFile.click();
    },
    confirmFile(filename = null) {
      try {
        const originalFile = this.$refs.sendFile.files[0];
        this.filename = this.generateTimestampedFilename(originalFile.name);
        this.newFileNamePrint = this.filename;
        var type = this.$refs.sendFile.files[0].type;
      } catch (err) {
        return;
      }
      var filesize = (this.$refs.sendFile.files[0].size / 1024 / 1024).toFixed(
        4
      ); // MB

      if (filesize > 10) {
        swal("Arquivo maior que quantidade permitida (10MB)", {
          icon: "warning",
        });

        return;
      }


      const formatos_aceitaveis = [
        "application/zip",
        "text/plain",
        "application/pdf",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "image/webp",
        "image/jpeg",
        "image/png",
        "text/csv",
        "application/msword",
        'audio/wav',
        'audio/mpeg'
      ];

      if (!formatos_aceitaveis.includes(type)) {
        swal("Formato inválido", {
          icon: "warning",
        });
        return;
      }
      this.modal = true;
    },
    sendFile(first = false) {
      var file = this.$refs.sendFile.files[0];
      this.modal = false;
      const fName = this.newFileNamePrint || file.name;
      this.addMsg(first, null, file, fName, file.type);
    },
    sendSelectedFile(blob, first = false) {
      const filename = this.generateTimestampedFilename("arquivo.pdf");
      const file = new File([blob], filename, {
        type: 'application/pdf'
      });
      this.addMsg(first, null, file, file.name, file.type);
    },
    btnClose() {
      this.modal = false;
    },
    endCurrChat() {
      this.alertEndChat();
    },
    alertEndChat() {
      let subjectObj = {
        subject: '',
        otherSubject: ''
      }
      return Swal.fire({
        title: "Finalizar atendimento",
        text: "Deseja finalizar o atendimento?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Finalizar",
        cancelButtonText: "Cancelar",
      }).then(async (willDelete) => {
        if (willDelete.value) {
          await this.endCurrentConversa();
          swal("Atendimento finalizado com sucesso", {
            icon: "success",
          });
        }
      });
    },
    transferir() {
      this.transfProcess();
    },
    openModalTransf() {
      this.$refs.modalTrans.openModal();
    },
    async fileToClipboard(e) {
      const files = e.clipboardData.files;
      if (files.length) {
        const file = files[0];
        if (file.name) {
          this.filename = this.generateTimestampedFilename(file.name);
          this.newFileNamePrint = this.filename;
 
        }
      }
      this.$refs.sendFile.files = files;
      this.confirmFile(this.newFileNamePrint);
    },
    start(data) {
      this.addTemplateMsg(data);
      this.showTemplate = false;
    },
    sessionValidate(sessionDate) {
      const dateLog = moment(sessionDate);
      const now = moment();
      return now.diff(dateLog) >= 86400000;
    },
    behaviorTemplateComp(myLog) {
      if (!myLog) return;
      this.first = myLog.first === 'true' ? true : false;
      if (myLog?.sendTemplate === "true") {
        this.showTemplate = true;
        return;
      }

      if (this.sessionValidate(myLog.sessionDate)) {
        this.showTemplate = true;
        return;
      }

      this.showTemplate = false;
    },
    async updateMsgsQueue(queue) {
      this.changeMsgQueue(queue);
      await this.sleep(1000);
      this.showMsgsQueue = false;
      if(this.getMsgQueue.length && !this.first) {
        this.sendMsgQueue();
      }
    },
    closeMsgsQueueModal() {
      this.showMsgsQueue = false;
      if(this.getMsgQueue.length && !this.first) {
        this.sendMsgQueue();
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async getAllTemplates(){
      const chatQueues = user.getChatQueues()
      const queues_ids = []
      if(chatQueues.length){
        chatQueues.map(el => queues_ids.push(parseInt(el)))
      }
      this.dbTemplates = await axios.post('/getDbTemplates', {queues_ids}).then(({data}) => data);
      await axios.get(`https://api.advancemanagement.com.br:${process.env.MIX_WEBHOOK_PORT}/get_template_list`)
        .then(({ data }) => {
          let tempArray = []
          if (data.length){
            data.map(temp => {
              if(this.dbTemplates.find(el => el.template_id === temp.id)) tempArray.push(temp)
            })
          } 
          this.allTemplates = tempArray;
        });
    }
  },
  computed: {
    ...mapGetters([
      "getTemCurrentConversa",
      "getCurrentConversa",
      "getCurrentConversaIndex",
      "getDataLog",
      "getMsgQueue"
    ]),
    queueVoiceRecorder() {
      return this.first || this.showMsgsQueue;
    }
  },
  watch: {
    async getCurrentConversaIndex() {
      if (!typeof this.getCurrentConversaIndex === 'number') return;
      this.scrollMsg();
      this.behaviorTemplateComp(this.getDataLog);
    },
    async getDataLog(myLog) {
      this.behaviorTemplateComp(myLog);
    },
    getTemCurrentConversa: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          const myNewVal = Object.values(newVal)[0];
          this.first =  myNewVal.first === 'true' ? true : false;

          if(this.getMsgQueue.length && !this.first && !this.showMsgsQueue) {
            this.sendMsgQueue();
          }
          this.clientName = myNewVal.client
          this.clientCpfCnpj = myNewVal.cpf_cnpj
        }
      },
    },
  },
  mounted() {
    this.listenSessionEvents();
    this.listenMsgQueue();
    this.transferOptions();
    $eventMessage.$on('sendMensagem', (msg) => {
      this.msg = msg;
    });
    this.getAllTemplates()
  }
};
</script>

<style>
._3qlW9 {
  align-items: center;
  -webkit-flex-grow: 1;
  flex-grow: 1;
  -webkit-justify-content: center;
  justify-content: center;
  z-index: 1;
  display: flex;
  height: 100%
}

._3qlW9:after {
  bottom: 0;
  height: 0
}

._3qlW9 a {
  color: #07bc4c
}

._2Uo0Z {
  width: 256px;
  height: 255px;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-attachment: fixed;
  background-position: 50% 50%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.iHhHL {
  color: #4b5961;
  font-size: 36px;
  font-weight: 300;
  text-align: center;
}

._1ClcF {
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}

._3zFlu {
  height: 1px;
  margin: 20px 0px 20px 0px;
  background-color: #E1E9EB
}

._3cK8a {
  font-size: 14px;
  line-height: 20px;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-align-items: center;
  align-items: center
}

._1Y6o1 {
  display: table;
  margin: 0 auto;
}

._1lrYJ {
  margin-left: 5px;
  margin-right: 5px;
}

::-webkit-scrollbar {
  width: 6px !important;
  height: 6px !important
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, .2)
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, .08)
}

.select2-dropdown {
  z-index: 9001;
}

.transferir {
  background-color: #fcaf26;
}

.custom-chat {
  display: flex;
  flex-direction: column;
}

.text-area {
  height: 3em;
  display: flex;
  margin-top: 1em;
  margin-left: 1em;
  margin-bottom: 0.5em;
  flex: 3;
}

.mensagens {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
</style>

<style scoped>
.form-control {
  border-radius: 0.5em 0.5em 0.5em 0.5em !important;
  margin-right: 1em;
  resize: none;
}

img {
  width: 130%;
}

.button-send-absolut {
  /* position: absolute; */
  right: 18.6em;
  bottom: 1em;
  border-radius: 50% !important;
  background-color: rgba(0, 0, 0, 0);
  color: #1c869a !important;
  border: none;
}

.chatMensagem-button {
  border-radius: 0.25em !important;
  margin-right: 0.25em;
}

.widthButton {
  width: 100%;
}

.btn-emoji {
  background: #ffff;
  border-color: rgba(127, 127, 127, 0.3);
  margin-right: 1em;
  border-radius: 0.25em !important;
  border-width: 1px;
}

.btn-emoji:hover {
  background-color: rgba(127, 127, 127, 0.2);
  ;
  color: white;
}

.emoji-frame {
  position: absolute;
  z-index: 1;
  margin-top: -420px;
  margin-left: -350px;
  background-color: #f6f6f6;
}

#msg-rapida-botao {
  font-size: 12px;
  width: 200px;
  margin: 0;
  border: 1px solid lightblue;
  font-weight: bold;
  color: #33839d;
  border-radius: 9px !important;
  margin-right: 10px;
  background-color: white;
}

#msg-rapida-botao:hover {
  background-color: rgb(91 154 175);
  color: white;
  transition: 0.2s;
}

#finalizar {
  height: 3em;
  align-self: center;
  margin: 1em;
}

.send-button {
  color: white;
  background-color: #1c869a;
  border-radius: 20px !important;
  padding: 0px 10px;
  height: 40px;
  align-self: center;
  box-shadow: 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%), 0 3px 5px -1px rgb(0 0 0 / 20%);
}

.send-button:hover {
  color: #1c869a;
  background-color: #1c859aa8;
  transition: 0.3s;
}

.schedule-button {
  color: white;
  background-color: #fcaf26;
  border-radius: 20px !important;
  padding: 0px 10px;
  height: 40px;
  align-self: center;
  box-shadow: 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%), 0 3px 5px -1px rgb(0 0 0 / 20%);
}

.schedule-button:hover {
  background-color: #cb8f23;
  transition: 0.3s;
}

#start-button {
  height: 3em;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1em;
  margin-left: 1em;
  margin-bottom: 0.5em;
  flex: 3;
  border-radius: 0.25em !important;
  background-color: #1c869a;
  color: white;
  font-weight: bold;
  cursor: pointer;
}

#start-button>span {
  color: white;
  font-weight: bold;
}

#start-button:hover {
  background-color: #156776;
}

.msg-queue-count {
  position: absolute;
  right: 0;
  top: 0;
  margin-top: -5px;
  margin-right: -5px;
  background-color: red;
  color: white;
  border-radius: 50%;
  min-width: 20px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  font-size: smaller;
}

.msg-queue-alert {
  align-self: center;
  span {
    background-color: white;
    width: fit-content;
    align-self: center;
    padding: 1px 10px;
    border-radius: 20px;
    box-shadow: 1px 1px 5px 1px gray;
    font-weight: bold;
    color: #1c869a;
    font-size: small;
    cursor: pointer;
    transition: 0.3s;
    border: 2px solid #1c869a;

    &:hover {
      background-color: rgba(255, 255, 255, 0.7);
    }
  }

  i {
    background-color: #1c869a;
    color: white;
    border-radius: 50%;
    padding: 5px;
    margin-left: 5px;
    cursor: help;
    font-size: smaller;
    width: 20px;
    text-align: center;
  }

}
</style>
